import * as types from "./actionsTypes";
import submittingRequestStatus from "./submittingRequestStatusAction";
import * as API from "../utils/apiPath";
import { agent } from "../utils/agent";
import { showToaster, setToaster, showErrorToaster } from "../utils/helpers";
import toggleNetworkRequestStatus from "./toggleNetworkRequestStatus";

export function loginDataSuccess(userInfo) {
  return { type: types.LOADED_USER_INFO_SUCCESS, userInfo };
}

export function setUserRole(role) {
  return { type: types.SET_USER_ROLE, role };
}

export function RegisterDataSuccess(userInfo) {
  return { type: types.LOADED_USER_REGISTER_SUCCESS, userInfo };
}

export function loadDataSuccess(customerData) {
  return { type: types.LOADED_CUSTOMER_DATA_SUCCESS, customerData };
}

export function loginUserLoginSuccess(isAuth) {
  return { type: types.LOADED_USER_AUTH_SUCCESS, isAuth };
}

export function ParamsDataSuccess(superUserParams) {
  return { type: types.LOADED_USER_PARAM_SUCCESS, superUserParams };
}

export function ForgotPasswordDataSuccess(isFrogot) {
  return { type: types.LOADED_USER_FORGOT_SUCCESS, isFrogot };
}

export function loadViewDataSuccess(updateProfileData) {
  return { type: types.LOADED_UPDATE_PROFILE_SUCCESS, updateProfileData };
}

export function loadExperienceDataSuccess(userExperience) {
  return { type: types.LOADED_EXPERIENCE_DATA_SUCCESS, userExperience };
}

export function loadProgrammesDataSuccess(programmes) {
  return { type: types.LOAD_PROGRAMMES_DATA_SUCCESS, programmes };
}


export function userLoginData(params) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));
    try {
      const response = await agent.post(API.LOGIN, params);

      if (response.status === 200) {
        dispatch(submittingRequestStatus(false));
        dispatch(loginDataSuccess(response.data.data));

        localStorage.setItem("userToken", response.data.data.api_token);
        localStorage.setItem("isConfirmed", response?.data?.data?.isConfirmed);

        dispatch(loginUserLoginSuccess(true));

        if (params.remember_me) {
          dispatch(ParamsDataSuccess(params));
        } else {
          dispatch(ParamsDataSuccess({}));
        }

        dispatch({
          type: "REDIRECT",
          payload: "/manage-profile",
        });
      }

      // ✅ Return the full response for component handling
      return response.data;
    } catch (error) {
      dispatch(submittingRequestStatus(false));
      // ✅ Return error to be handled in component
      return {
        status: error?.status || 500,
        message: error?.message || error.message,
      };
    }
  };
}



// Helper function to determine redirect path based on step
function getRedirectPath(step) {
  const stepRedirects = {
    "step_1": "/registration-step-1",
    "step_2": "/registration-step-2", 
    "step_3": "/registration-step-3",
    "step_4": "/registration-step-4"
  };
  
  return stepRedirects[step] || null;
}

function handleStep5Logic(terminateProcess, paramsLogin, dispatch) {
  if (terminateProcess === "No" && paramsLogin) {
    dispatch(userLoginData(paramsLogin));
  }
  return "/";
}


// Helper function to handle successful registration response
function handleSuccessfulRegistration(response, terminateProcess, step, paramsLogin, dispatch) {
  dispatch(RegisterDataSuccess(true));

  // Early return for terminate process
  if (terminateProcess === "Yes") {
    return {
      success: true,
      message: response.data.message,
      redirectTo: "/"
    };
  }

  // Handle step-based redirects
  let redirectTo = getRedirectPath(step);

  if (step === "step_5") {
    redirectTo = handleStep5Logic(terminateProcess, paramsLogin, dispatch);
    localStorage.removeItem("userId");
  }

  return {
    success: true,
    message: response.data.message,
    redirectTo,
  };
}

export function userRegisterData(params, roleId, userId, terminateProcess, step, paramsLogin) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));

    try {
      const response = await agent.post(
        API.REGISTER_NEW,
        params,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );

      localStorage.setItem("userId", userId);

      // Handle service unavailable
      if (response.status === 503) {
        dispatch(submittingRequestStatus(false));
        return { success: false, message: response.data.message };
      }

      // Handle successful response
      if (response.status === 200) {
        dispatch(submittingRequestStatus(false));

        if (response?.data?.status === 200) {
          return handleSuccessfulRegistration(response, terminateProcess, step, paramsLogin, dispatch);
        }

        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(submittingRequestStatus(false));
      return { success: false, message: error.message };
    }
  };
}

export function userRegisterDataInSingleStep(params, roleId, userId) {

  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));
    await agent
      .post(API.REGISTER_NEW, params)
      .then((response) => {
        localStorage.setItem("userId", userId);
        if (response.status === 503) {
          showErrorToaster(response.data.message);
          dispatch(submittingRequestStatus(false));
        }
        if (response.status === 200) {
          if (response?.data?.status === 200) {
            showToaster(response.data.message);
            dispatch(submittingRequestStatus(false));
            dispatch(RegisterDataSuccess(true));
            dispatch({
              type: "REDIRECT",
              payload: "/",
            });
          } else {
            showToaster(response.data.message);
            dispatch(submittingRequestStatus(false));
          }
        }
      })
      .catch((error) => {
        showErrorToaster(error.message);
        dispatch(submittingRequestStatus(false));
      });
  };
}

export const getExperienceUser = (request) => async (dispatch) => {
  try {
    dispatch(toggleNetworkRequestStatus(true));
    const response = await agent.get(API.EXPERIENCE);
    dispatch(loadExperienceDataSuccess(response.data?.data));
    dispatch(toggleNetworkRequestStatus(false));
  } catch (error) {
    showErrorToaster(error.message);
    dispatch(toggleNetworkRequestStatus(false));
  }
};


export function forgotPassword(params) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));

    try {
      const response = await agent.post(API.FORGOT_PASSWORD, params);

      dispatch(submittingRequestStatus(false));
      dispatch(ForgotPasswordDataSuccess(true));

      // return response to component
      return { success: true, message: response.data.message };

    } catch (error) {
      dispatch(submittingRequestStatus(false));

      return { success: false, message: error.message || "Something went wrong" };
    }
  };
}

export function userLogout(params) {
  return async function (dispatch) {
    dispatch(loginUserLoginSuccess(false));
    dispatch(loginDataSuccess({}));
    localStorage.removeItem("userRole");
    localStorage.removeItem("userToken");
    localStorage.removeItem("profileImage");
    localStorage.removeItem("profile_img");
    localStorage.removeItem("userRole");
    localStorage.removeItem("mentorEligibilityPopupShown");
  };
}

export const updateProfileData = (params) => async (dispatch) => {
  try {
    dispatch(submittingRequestStatus(true));
    const response = await agent.post(API.UPDATE_PROFILE, params);
    dispatch(submittingRequestStatus(false));
    showToaster(response.data.message);
    dispatch(loadViewDataSuccess(response.data.data));
  } catch (error) {
    dispatch(submittingRequestStatus(false));
    showErrorToaster(error.message);
  }
};

export const updatePasswordData = (params) => async (dispatch) => {
  try {
    dispatch(submittingRequestStatus(true));
    const response = await agent.put(API.UPDATE_PASSWORD + "/" + params.id, params);

    dispatch(submittingRequestStatus(false));

    if (response.status === 200) {
      // Clear tokens
      localStorage.setItem("authToken", "");
      localStorage.removeItem("userToken");
      localStorage.removeItem("token");
      localStorage.removeItem("profileImage");
      localStorage.removeItem("persist:root");
      localStorage.removeItem("profile_img");
      localStorage.removeItem("mentorEligibilityPopupShown");

      return {
        success: true,
        message: response.data.message,
      };
    } else {
      return {
        success: false,
        message: response.message,
      };
    }
  } catch (error) {
    dispatch(submittingRequestStatus(false));
    return {
      success: false,
      message: error.message || "Something went wrong",
    };
  }
};

export const getUserProfile = (request) => async (dispatch) => {
  try {
    const response = await agent.get(API.GETUSERPROFILE);
    dispatch(loadViewDataSuccess(response.data.data));
  } catch (error) {
    // Handle the error appropriately
    console.error('Failed to get user profile:', error);
  }
};

export const updateCustomerData = (params, id, role_id) => async (dispatch) => {
  try {
    const response = await agent.post(
      API.LOAD_CUSTOMER + "/update/" + id,
      params
    );
    dispatch(loadDataSuccess(response.data.data.data));
    setToaster(response.data.message);
  } catch (error) {
    setToaster(error.message);
  }
};

export function updateStep1(params, id, setLoader) {
  return async function (dispatch) {
    await agent
      .post(API.LOAD_CUSTOMER + "/saveStep1/" + id, params)
      .then((response) => {
        dispatch(loadViewDataSuccess(response.data.data));
        dispatch(loadDataSuccess(response.data.data.data));
        dispatch(loginDataSuccess(response.data.data));
        if (response.status === 422) {
          setLoader(false);
          showErrorToaster(response.data.message);
        }
        if (response.status === 503) {
          setToaster(response.data.message);
        }
        if (response.status === 200) {
          setToaster(response.data.message);
          setTimeout(
            () =>
              dispatch({
                type: "REDIRECT",
                payload: "manage-profile-step3",
              }),
            1800
          );
          localStorage.setItem(
            "isConfirmed",
            response?.data?.data?.isConfirmed
          );
        }
      })
      .catch((error) => {
        if (error.status === 422) {
          setLoader(false);
          showErrorToaster(error.message);
        } else {
          setToaster(error.message);
        }
      });
  };
}

export const updateUserAvailability = (params, id) => async (dispatch) => {
  try {
    const response = await agent.post(
      API.LOAD_CUSTOMER + "/updateUserAvailability/" + id,
      params
    );
    dispatch(loadDataSuccess(response.data.data.data));
    setToaster(response.data.message);
  } catch (error) {
    setToaster(error.message);
  }
};

export const updateStep2 = (params, id) => async (dispatch) => {
  try {
    const response = await agent.post(
      API.LOAD_CUSTOMER + "/saveStep2/" + id,
      params
    );
    dispatch(loadDataSuccess(response.data.data.data));
    setToaster(response.data.message);
    dispatch(loadViewDataSuccess(response.data.data));
    localStorage.setItem("isConfirmed", response?.data?.data?.isConfirmed);
  } catch (error) {
    setToaster(error.message);
  }
};

export function updateStep3(params, id) {
  return async function (dispatch) {
    await agent
      .post(API.LOAD_CUSTOMER + "/saveStep3/" + id, params)
      .then((response) => {
        dispatch(loadDataSuccess(response.data.data.data));

        if (response.status === 503) {
          setToaster(response.data.message);
        }
        if (response.status === 200) {
          dispatch(loadViewDataSuccess(response.data.data));
          setToaster(response.data.message);
          setTimeout(
            () =>
              dispatch({
                type: "REDIRECT",
                payload: "manage-profile-step4",
              }),
            1800
          );
          localStorage.setItem(
            "isConfirmed",
            response?.data?.data?.isConfirmed
          );
        }
      })
      .catch((error) => {
        setToaster(error.message);
      });
  };
}

export const updateStep4 = (params, id) => async (dispatch) => {
  try {
    const response = await agent.post(
      API.LOAD_CUSTOMER + "/saveStep4/" + id,
      params
    );
    dispatch(loadDataSuccess(response.data.data.data));
    dispatch(loadViewDataSuccess(response.data.data));
    localStorage.setItem("isConfirmed", response?.data?.data?.isConfirmed);
    setToaster(response.data.message);
  } catch (error) {
    setToaster(error.message);
  }
};


export function DeleteRequest(params, id) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));

    try {
      const response = await agent.post(API.LOAD_CUSTOMER + "/deleteRequest/" + id, params);

      dispatch(submittingRequestStatus(false));

      if (response.status === 503) {
        return { success: false, message: response.data.message };
      }

      if (response.status === 200) {
        dispatch(RegisterDataSuccess(true));
        return { success: true, message: response.data.message };
      }

    } catch (error) {
      dispatch(submittingRequestStatus(false));
      return { success: false, message: error.message };
    }
  };
}


export function Refer(params) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));

    try {
      const response = await agent.post(API.SEND_REFER, params);
      dispatch(submittingRequestStatus(false));

      // ✅ Return standardized data for the component
      return {
        status: response?.status || response?.data?.status,
        message: response?.data?.message || "Request completed successfully.",
      };
    } catch (error) {
      dispatch(submittingRequestStatus(false));
      return {
        status: error?.response?.status || 500,
        message: error?.response?.data?.message || "Something went wrong. Please try again.",
      };
    }
  };
}

export const getAllProgrammes = (request) => async (dispatch) => {
  try {
    const response = await agent.get(API.LOAD_PROGRAMMES + "/all");
    dispatch(loadProgrammesDataSuccess(response.data.data));
  } catch (error) {
    showErrorToaster(error.message);
  }
};


export function preregistrationFrom(params) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));
    try {
      const response = await agent.post(API.PRE_REGISTER, params);

      dispatch(submittingRequestStatus(false));

      // Return response to the component
      return response;

    } catch (error) {
      dispatch(submittingRequestStatus(false));

      // Return the error to the component
      return { error: error.message || "Something went wrong" };
    }
  };
}

